// Generated by scripts/sync-bindings.ts (the `lang` query enum in specs/openapi.json). Do not edit.

/**
 * Every language tag the API accepts on `?lang=`.
 *
 * @remarks
 * A self-fetch resolves the site language from the DOM, which means ANY value a
 * host page happens to carry can reach the query string. The API rejects an
 * unlisted tag with a 400, so a page in a language we do not translate would
 * stop working the moment the language chain was completed. Membership is
 * checked against this list before `lang` is sent, and a miss simply omits the
 * parameter, leaving the endpoint on its English default.
 */
export const API_LANGUAGES: readonly string[] = ["de","en","es","fr","hi","pt","ru","tr","zh-Hans","zh-Hant"];
